module.exports = __webpack_public_path__ + "static/media/cnsa.152ce713.jpg";